<template>
  <svg role="presentation" class="icon" width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
    <rect class="cls-1" x="1.75" y="2.75" width="8.5" height="8" rx="0.75" />
    <path class="cls-1" d="M8.5 4.5V1.5C8.5 1.22386 8.27614 1 8 1H4C3.72386 1 3.5 1.22386 3.5 1.5V4.5" />
  </svg>
</template>
<script>
export default {
  name: 'ShopIcon'
}
</script>
<style lang="scss" scoped>
.icon {
  height: 2.4rem;
  width: 2.4rem;
}

.cls-1 {
  fill: none;
  stroke: var(--_zenith-header-text-link, var(--zenith-white));
  // stroke-linecap: round;
  // stroke-linejoin: round;
}
</style>
